import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import Sidebar from "../components/SellerComponents/SellerSidebar/Sidebar";
import Navbar from "../components/SellerComponents/SellerHeader/Navbar";
import "../SellerResponsive.css";
import "./SellerLayout.css";
import { Helmet } from "react-helmet";

const { Content, Header: AntHeader } = Layout;
const DESKTOP_BREAKPOINT = 992;

export const SellerLayout = (props) => {
  const isMobileViewport =
    typeof window !== "undefined" && window.innerWidth < DESKTOP_BREAKPOINT;

  const [collapsed, setCollapsed] = useState(() => {
    const storedCollapsed = localStorage.getItem("collapsed");
    return storedCollapsed !== null ? JSON.parse(storedCollapsed) : isMobileViewport;
  });

  useEffect(() => {
    localStorage.setItem("collapsed", JSON.stringify(collapsed));
  }, [collapsed]);

  useEffect(() => {
    const syncSidebarWithViewport = () => {
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        setCollapsed(false);
      } else {
        setCollapsed(true);
      }
    };

    syncSidebarWithViewport();
    window.addEventListener("resize", syncSidebarWithViewport);
    return () => window.removeEventListener("resize", syncSidebarWithViewport);
  }, []);

  return (
    <Layout
      className={`layout-dashboard layout-profile seller-layout-root ${collapsed ? "menu-collapsed" : ""}`}
      style={{ height: "100vh", overflow: "hidden" }}
    >
      <Helmet>
        <title>MOB - Seller Portal</title>
      </Helmet>

      <AntHeader className="seller-layout-header">
        <Navbar collapsed={collapsed} setCollapsed={setCollapsed} />
      </AntHeader>

      <Layout style={{ flex: 1, overflow: "hidden", minHeight: 0 }}>
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content
          style={{ overflow: "auto" }}
          className="content-ant seller-layout-content"
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};
export default SellerLayout;
